function setCssSupport() {
  if(!window.CSS) {
    window.CSS = {};
  }
  if(!window.CSS.supports) {
    window.CSS.supports = function() {
        return false;
    };
  }
}

function setConsoleLog() {
  if(!console && !console.log) {
    console = {
      log: function() {}
    }
  }
}

setCssSupport();
setConsoleLog();
